import { useTranslations } from '@vocab/react';
import { Divider, Stack } from 'braid-design-system';
import { useCallback } from 'react';

import { useIsHomepageGenAIChatDecardWidgetEnabled } from 'src/store/featureFlags/hooks';

import translations from '../.vocab';
import { CareerFeedMobileWebFeatureFlagContainer } from '../CareerFeedMobileWebFeatureFlagContainer';
import RefreshRecommendationsButton from '../RefreshRecommendationsButton';
import { useGetResetCandidateChatContext } from '../hooks/candidateChatContextHelpers';
import { useCareerFeedAIAssistant } from '../hooks/useCareerFeedAIAssistant';

import { CareerFeedAIAssistantContentFrame } from './CareerFeedAIAssistantContentFrame';
import { TextSection } from './TextSection';

export const RecommendationRefinedConfirmation = () => {
  const resetPreferences = useGetResetCandidateChatContext();
  const {
    tracking: { trackGenAIChatResetPressed },
  } = useCareerFeedAIAssistant();
  const { t } = useTranslations(translations);

  const onReset = useCallback(() => {
    trackGenAIChatResetPressed('chat widget');
    resetPreferences();
  }, [resetPreferences, trackGenAIChatResetPressed]);

  const isHomepageGenAIChatDecardWidgetEnabled =
    useIsHomepageGenAIChatDecardWidgetEnabled();
  return (
    <CareerFeedMobileWebFeatureFlagContainer
      mobileView={
        isHomepageGenAIChatDecardWidgetEnabled ? (
          <Stack space="small">
            <TextSection>
              {t(
                "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
              )}
            </TextSection>
            <RefreshRecommendationsButton onReset={onReset} />
          </Stack>
        ) : (
          <CareerFeedAIAssistantContentFrame
            widgetHeadMessage={t(
              "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
            )}
            widgetCtaSection={
              <>
                <Divider />
                <RefreshRecommendationsButton onReset={onReset} />
              </>
            }
            widgetContentSection={<></>}
            loadingOnDrawer={
              false /* Loading is just used for loading overlay, we don't want this on the final q */
            }
            loadingOnWidget={false}
          />
        )
      }
      tabletAndAboveView={
        <CareerFeedAIAssistantContentFrame
          widgetHeadMessage={t(
            "We've updated your recommendations based on your answers. Take a look at the personalised job listings.",
          )}
          widgetCtaSection={<RefreshRecommendationsButton onReset={onReset} />}
          widgetContentSection={<></>}
          loadingOnDrawer={
            false /* Loading is just used for loading overlay, we don't want this on the final q */
          }
          loadingOnWidget={false}
        />
      }
    />
  );
};
